module.exports = __webpack_public_path__ + "static/media/help-img3.37a2a2c8.png";